export default __webpack_public_path__ + "static/1441-d50f6804cdf9d873b2cb59a9a40cf7af.gif";